import type {TFunction} from 'i18next'

interface ValidationRules {
  required: {
    value: boolean
    message: string
  }
}

export const requiredValidator = (t: TFunction): ValidationRules => ({
  required: {
    value: true,
    message: t('common.validation.required')
  }
})
